import get from "lodash/get";
import {
  TOGGLE_PERFORMANCE_DRAWER_VISIBILITY,
  PERFORMANCE_REPORT_LOADING,
  PERFORMANCE_REPORT_SUCCESS,
  PERFORMANCE_REPORT_FAILED,
  PERFORMANCE_REPORT_LIST_LOADING,
  PERFORMANCE_REPORT_LIST_SUCCESS,
  PERFORMANCE_REPORT_LIST_FAILED,
  PERFORMANCE_REPORT_SUCCESS_NEW_PRIMER,
  RESET_PERFORMANCE_REPORT,
  RESET_PERFORMANCE_REPORT_NEW_PRIMER
} from "../../actionTypeConstants/ml2.0/PerformanceReport";

const initialState = {
  reportNames: [],
  error: null,
  isPerformanceDrawerVisible: false,
  loading: true,
  isReportLoading: false,
  report: null,
  reportError: null
};

export default function reducer(state = initialState, action = {}) {
  switch (action.type) {
    case PERFORMANCE_REPORT_LIST_LOADING: {
      return {
        ...state,
        loading: true,
        reportNames: []
      };
    }

    case PERFORMANCE_REPORT_LIST_SUCCESS: {
      console.log("here", action.result.data.data);
      return {
        ...state,
        reportNames: action.result.data.data,
        loading: false,
        error: null
      };
    }

    case PERFORMANCE_REPORT_LIST_FAILED: {
      return {
        ...state,
        reportNames: [],
        loading: false,
        error: action.error
      };
    }

    case PERFORMANCE_REPORT_LOADING: {
      return {
        ...state,
        isReportLoading: true
      };
    }

    case PERFORMANCE_REPORT_SUCCESS: {
      const { areLogsFetchedFromLTMA = false } = action.payload;
      const performanceLogs = areLogsFetchedFromLTMA
        ? action.result.data
        : action.result.data.data;
      return {
        ...state,
        report: performanceLogs,
        isReportLoading: false,
        reportError: null
      };
    }

    case PERFORMANCE_REPORT_SUCCESS_NEW_PRIMER: {
      const {
        areLogsFetchedFromLTMA = false,
        reportName = ""
      } = action.payload;
      const performanceLogs = areLogsFetchedFromLTMA
        ? action.result.data
        : action.result.data.data;

      return {
        ...state,
        report: { ...state.report, [reportName]: performanceLogs },
        isReportLoading: false,
        reportError: null
      };
    }

    case PERFORMANCE_REPORT_FAILED: {
      const errorMsg = get(action, ["error", "response", "data", "error"]);
      return {
        ...state,
        report: null,
        isReportLoading: false,
        reportError: errorMsg
      };
    }

    case TOGGLE_PERFORMANCE_DRAWER_VISIBILITY: {
      const { isVisible } = action.payload;
      return {
        ...state,
        isPerformanceDrawerVisible: isVisible
      };
    }

    case RESET_PERFORMANCE_REPORT: {
      return {
        ...state,
        report: null,
        isReportLoading: false,
        reportError: null
      };
    }

    case RESET_PERFORMANCE_REPORT_NEW_PRIMER: {
      return {
        ...state,
        reportNames: [],
        error: null,
        loading: true,
        isReportLoading: false,
        report: null,
        reportError: null
      };
    }

    default: {
      return state;
    }
  }
}
